import React, { Suspense, lazy } from "react";
import { createRoot } from 'react-dom/client';
// import { Provider } from "react-redux";
// import { PersistGate } from 'redux-persist/integration/react'
// import { store, persistor } from "./redux/storeConfig/store";
// import './App.css';
// import "primereact/resources/themes/vela-blue/theme.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import './ReactotronConfig'
// import "font-awesome/css/font-awesome.min.css";
import "./index.scss";
import Spinner from "./components/spinner/spinner";

const LazyApp = lazy(() => import("./app/app"));

const root = createRoot(document.getElementById('root'));
root.render(
   <Suspense fallback={<Spinner />}>
      <LazyApp />
   </Suspense>
   //  <Provider store={store}> 
   //     <PersistGate loading={null} persistor={persistor}>

   //    </PersistGate> 
   // </Provider> 
);